export default __webpack_public_path__ + "static/media/responder.b7aaa654.png";